import descriptionsRu from "./propertyDescriptions.ru";

export function getDescription(property, lang) {
  if (lang === "ru") {
    return descriptionsRu[property.reference] ?? property.description;
  }
  return property.description;
}
